var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.244,
    height: 8.083,
    viewBox: "0 0 8.244 8.083",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "No",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbol_85_1",
    "data-name": "Symbol 85 \\u2013 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Uni\\xF3n_3",
    "data-name": "Uni\\xF3n 3",
    d: "M7.288,7.923l-3.166-3.1L.956,7.923a.568.568,0,0,1-.792,0,.543.543,0,0,1,0-.777l3.166-3.1L.164.937a.542.542,0,0,1,0-.776.568.568,0,0,1,.792,0l3.166,3.1L7.288.161a.568.568,0,0,1,.792,0,.541.541,0,0,1,0,.776l-3.166,3.1,3.166,3.1a.542.542,0,0,1,0,.777.568.568,0,0,1-.792,0Z",
    transform: "translate(0)",
    fill: "#f1f1f1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNo);
export default __webpack_public_path__ + "static/media/No.9a3976b4121d9aa75e7fd5138e2cdb42.svg";
export { ForwardRef as ReactComponent };